/* ============
 * The initial state of the profile module.
 * ============
 */
export default {
  groups: [],
  group: {
    id: '',
    name: '',
    description: '',
    isEditing: false,
  },
  isLoading: false,
  isBusy: false,
  groupUserInfo: {
    totalCount: 0,
    patientList: []
  },
  getGroupInfo: null
};

